import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { activateFamilyMember, fetchFamilyMemberById } from "../../service/FamilyMemberApi";
import { fetchFamilyById } from "../../service/FamilyApi";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { Loading } from "../../components/shared";
import { businessNames, relationShips } from '../general/DropDownValuesConfig';
import { useCheckAccess, maskAadhar, getYearOptions } from "../../utils/Utilities";


function FamilyMemberActivate() {
  useCheckAccess('FamilyRW'); // Check if the user is logged in (if no user data, redirect to login)
  const { id } = useParams();

  const navigate = useNavigate();
  const [familyData, setFamilyData] = useState(null);
  const [familyMemberData, setFamilyMemberData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const dateInputRef = useRef(null);
  const [selectedYear, setSelectedYear] = useState("");
  // React Hook Form setup
  const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm();
  //const [parentId, setParentId] = React.useState(""); // State to store selected Parent ID

  const [loading, setLoading] = React.useState(false);

  const [error, setError] = useState(null);

  // Fetch family data
  useEffect(() => {
    const fetchFamilyMemberData = async () => {
      try {
        if (id) {
          const data = await fetchFamilyMemberById(id);
          setFamilyMemberData(data); // Set the fetched data to state
          // Pre-populate the form with fetched data when editing
          setValue("firstName", data.familyMember.firstName || "");
          setValue("lastName", data.familyMember.lastName || "");
          setValue("businessName", data.familyMember.businessName || "");
          setValue("dob", data.familyMember.dob || "");
          setValue("mobile", data.familyMember.mobile || "");
          setValue("mobile2", data.familyMember.mobile2 || "");
          setValue("email", data.familyMember.email || "");
          setValue("aadhar", data.familyMember.aadhar || "");
          setValue("status", data.familyMember.status || "");
          setValue("parentId", data.familyMember.parentId || data.familyMember.aadhar);
          //setFamilyIdFromMember(data.familyMember.familyId);
          const dataFamliy = await fetchFamilyById(data.familyMember.familyId); // Await the fetchFamilyById function
          setFamilyData(dataFamliy); // Set the family data in state
        }
      } catch (error) {
        setError("Error fetching family member data");
      }
    };

    fetchFamilyMemberData();

  }, [id, setValue]);

  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    const dateString = `${year}-06-01`;

    // Update both DOM and react-hook-form state
    if (dateInputRef.current) {
      dateInputRef.current.value = dateString;
    }
    setValue("dob", dateString, { shouldValidate: true });
  };

  // Handle form submission (API update)
  const onSubmit = async (data) => {
    if (loading) {
      return;  // Prevent form submission if loading is true
    }
    setLoading(true);
    try {
      if (data) {
        if (data.newAadhar && data.newAadhar.startsWith("00")) {
          data.status = "draft";
        }
        const payload = {
          ...data,
          uid: familyMemberData.familyMember.uid,
        };
        const success = await activateFamilyMember(payload);
        if (success) {
          navigate(`/family/view/${familyMemberData.familyMember.familyId}`);
        }
      }
    } catch (error) {
      console.error("Error activating family member:", error);
    } finally {
      setLoading(false);  // Set loading back to false after completion
    }

    setIsEditing(false);

  };
  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }
  // If data is not available, show loading
  if (!familyMemberData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Helmet>
        <title>Activate Family Member</title>
        <link rel="canonical" href={`/family/member-update`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">

            <h3>{isEditing ? "Edit Family Member Details" : "Activate Family Member Details"}</h3>
            <Breadcrumbs /><br />
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <input
                type="hidden"
                {...register("id")} // Register the id field
                value={familyMemberData.familyMember.id}  // Set the value to the correct id
              />
              <input
                type="hidden"
                {...register("aadhar")} // Register the id field
                value={familyMemberData.familyMember.aadhar}  // Set the value to the correct id
              />

              <input
                type="hidden"
                {...register("familyId")} // Register the id field
                value={familyMemberData.familyMember.familyId}  // Set the value to the correct id
              />


              <div className="details-card">
                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்ப எண் :</strong></span>
                  <span className="detail-value">{familyMemberData.familyMember.familyId}</span>
                </div>

                {/* Aadhar Number */}
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய ஆதார் எண்</strong></span>
                  <span>{maskAadhar(familyMemberData.familyMember.maskedAadhar) || "இல்லை"}</span>
                </div>
                <div className="auth_element">
                  <label className="auth_label">புதிய ஆதார் எண்</label>
                  <input
                    type="text"
                    id="newAadhar"
                    {...register("newAadhar", {
                      required: "புதிய ஆதார் எண் தேவை",
                      pattern: {
                        value: /^\d{12}$/,
                        message: "12 இலக்க எண் மட்டுமே அனுமதிக்கப்படுகிறது",
                      },
                    })}
                    className="auth_input"
                    defaultValue=""
                    placeholder="123456789012"
                  />
                  {errors.newAadhar && <div className="auth_error">{errors.newAadhar.message}</div>}
                </div>

                {/* First Name */}
                <div className="detail-item">
                  <span className="detail-label">பெயர்</span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="firstName"
                      {...register("firstName", {
                        required: "பெயர் தேவை",
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                    />
                  </div>
                  {errors.firstName && <div className="auth_error">{errors.firstName.message}</div>}
                </div>

                {/* Last Name */}
                <div className="detail-item">
                  <span className="detail-label">தந்தை/கணவர் பெயர்</span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="lastName"
                      {...register("lastName", {
                        required: "தந்தை/கணவர் பெயர் தேவை",
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                    />
                  </div>
                  {errors.lastName && <div className="auth_error">{errors.lastName.message}</div>}
                </div>

                {/* Optional Business Name Field */}
                <div className="auth_element">
                  <label className="auth_label">வணிக பெயர் (தேவையில்லை)</label>
                  <select
                    id="businessName"
                    {...register("businessName")}
                    className="auth_select"
                    defaultValue={familyMemberData?.familyMember.businessName || ""}

                  >
                    <option value="">--Select Business--</option>
                    {businessNames.map((business) => (
                      <option key={business.value} value={business.value}>
                        {business.label}
                      </option>
                    ))}
                  </select>
                  {errors.businessName && <div className="auth_error">{errors.businessName.message}</div>}
                </div>
                {/* Date of Birth */}
                <div className="auth_element">
                  <label className="auth_label">பிறந்த தேதி</label>

                  <div style={{ display: "flex", gap: "10px" }}>
                    {/* Year dropdown */}
                    <select
                      onChange={handleYearChange}
                      value={selectedYear}
                      className="auth_input"
                    >
                      <option value="">ஆண்டு தேர்வு செய்யவும்</option>
                      {getYearOptions(1940).map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>

                    {/* Actual date input */}
                    <input
                      type="date"
                      id="dob"
                      ref={dateInputRef}
                      {...register("dob")}
                      className="auth_input"
                    />
                  </div>

                  {errors.dob && (
                    <div className="auth_error">❗ {errors.dob.message}</div>
                  )}
                </div>
                {/* Mobile Numbers */}
                <div className="auth_element">
                  <label className="auth_label">கைபேசி எண் (தேவையில்லை)</label>
                  <input
                    type="tel"
                    id="mobile"
                    {...register("mobile", {
                      pattern: {
                        value: /^\d{10}$/,
                        message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                      },
                    })}
                    className="auth_input"
                    placeholder="+91-1234567890"
                    inputMode="numeric"
                  />
                  {errors.mobile && <div className="auth_error">{errors.mobile.message}</div>}
                </div>

                <div className="auth_element">
                  <label className="auth_label">கைபேசி எண் 2 (தேவையில்லை)</label>
                  <input
                    type="tel"
                    id="mobile2"
                    {...register("mobile2", {
                      pattern: {
                        value: /^\+91[-]?\d{3}[-]?\d{3}[-]?\d{4}$|^(?:\+?\d{1,3})?[-.\s]?(\(?\d{2,3}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
                        message: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
                      },
                    })}
                    className="auth_input"
                    placeholder="+91-1234567890"
                    inputMode="numeric"
                  />
                  {errors.mobile2 && <div className="auth_error">{errors.mobile2.message}</div>}
                </div>

                {/* Email */}
                <div className="auth_element">
                  <label className="auth_label">மின்னஞ்சல்(தேவையில்லை)</label>
                  <input
                    type="email"
                    id="email"
                    {...register("email", {
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+(?:[a-zA-Z0-9-]*[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "மின்னஞ்சல் செல்லுபடியாகாது",
                      },
                    })}
                    className="auth_input"
                    placeholder="ponnachiamman@gmail.com"
                  />
                  {errors.email && <div className="auth_error">{errors.email.message}</div>}
                </div>
                <div className="auth_element">
                  <span className="auth_label"><strong>நிலை:</strong></span>
                  <div className="auth_radio">
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", { required: "நிலை is required" })}
                      />
                      ✅ active
                    </label>
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", { required: "நிலை is required" })}
                      />
                      ❌ inactive
                    </label>
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="draft"
                        {...register("status", { required: "நிலை is required" })}
                      />
                      📝 draft
                    </label>
                    {errors.status && <div className="auth_error">{errors.status.message}</div>}
                  </div>
                </div>
                <div className="auth_element">
                  <label className="auth_label">குடும்ப உறவு</label>
                  <select
                    id="relationship"
                    {...register("relationship", { required: "உறவு தேர்ந்தெடுக்கவும்" })}
                    className="auth_select"
                    defaultValue={familyMemberData?.familyMember.relationship || ""}
                  >
                    <option value="">--Select Relationship--</option>
                    {relationShips.map((relation) => (
                      <option key={relation.value} value={relation.value}>
                        {relation.label}
                      </option>
                    ))}
                  </select>
                  {errors.relationship && <div className="auth_error">{errors.relationship.message}</div>}
                </div>
                {/* Parent ID Dropdown */}

                {familyData?.family?.familyMembers && (
                  <div className="auth_element">
                    <label className="auth_label">Parent ID (Aadhaar ID)</label>
                    <select
                      id="parentId"
                      {...register("parentId")}
                      className="auth_select"
                      value={watch("parentId")}
                    >
                      <option value="">--Select Parent ID--</option>
                      {familyData.family.familyMembers
                        .filter((member) => /^\d{12}$/.test(member.maskedAadhar)) // Only valid Aadhaar
                        .map((member) => (
                          <option key={member.aadhar} value={member.aadhar}>
                            {member.firstName} {member.lastName} ({maskAadhar(member.maskedAadhar)})
                          </option>
                        ))}
                    </select>
                    {errors.parentId && <div className="auth_error">{errors.parentId.message}</div>}
                  </div>
                )}

                <button
                  type="submit"
                  className="auth_submit"
                  disabled={loading}  // Disable the button when loading
                >
                  சமர்ப்பிக்கவும்
                </button>
                <br />
              </div>
            </form>

            <button onClick={() => navigate(`/family/member-create/${familyMemberData.familyMember.familyId}`)}>குடும்ப உறுப்பினரைச் சேர்</button>
            <br />
            <button onClick={() => navigate(`/family/view/${familyMemberData.familyMember.familyId}`)}>View Family</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyMemberActivate;
